import { ApolloError } from '@apollo/client'

import {
  GetCustomerSettingsPractitionerDocument,
  GetCustomerSettingsPractitionerQuery,
} from '../../../graphql/camel'
import useCamelQuery from '../../../hooks/useCamelQuery'
import type { PractitionerSettings } from '../types'
import { practitionerSettingsFromResponse } from '../utils'

export interface UsePractitionerSettingsEagerOptions {
  settings?: PractitionerSettings
}

export type UsePractitionerSettingsEager = {
  data: PractitionerSettings | undefined
  loading: boolean
  error: ApolloError | Error | undefined
  refetch: () => void
}

export const usePractitionerSettingsEager = (
  options?: UsePractitionerSettingsEagerOptions,
): UsePractitionerSettingsEager => {
  const settings = options && options.settings ? options.settings : undefined

  const { data, loading, error, refetch } = useCamelQuery<GetCustomerSettingsPractitionerQuery>(
    GetCustomerSettingsPractitionerDocument,
    {
      skip: !!settings,
    },
  )

  if (settings) {
    // No-op refetch because query is skipped when settings are provided
    return {
      data: settings,
      loading: false,
      error: undefined,
      refetch: () => {
        /* no-op */
      },
    }
  }

  const loadedSettings = data ? practitionerSettingsFromResponse(data) : undefined
  return { data: loadedSettings, loading, error, refetch }
}
